import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { useSearchParams } from 'react-router-dom'
const timeIntervalItems = [
  {
    label: '1M',
    value: 'MONTH',
  },
  {
    label: '3M',
    value: 'QUARTER',
  },
  {
    label: '1Y',
    value: 'YEAR',
  },
]

export default function FutureMineralPricesChartTimeIntervalSelect() {
  const [searchParams, setSearchParams] = useSearchParams()

  const { t } = useTranslation()
  const [selectedInterval, setSelectedInterval] = useState('MONTH')

  function handleOnClick(type) {
    setSelectedInterval(type)
    searchParams.set('INTERVAL', type)
    setSearchParams(searchParams)
  }

  return (
    <div className={`flex flex-col space-y-2 rtl:space-x-reverse`}>
      <label className={`font-bold`}>{t('TIME_INTERVAL')}</label>
      <div className={`flex space-x-2 rtl:space-x-reverse`}>
        {timeIntervalItems.map((item) => (
          <button
            onClick={() => handleOnClick(item.value)}
            className={`h-[38px] w-[38px] border-2 font-bold ${searchParams.get('INTERVAL') == item.value ? 'border-secondary-600 text-secondary-600 bg-light' : 'hover:border-secondary-600 hover:text-secondary-600 hover:bg-light'} p-1.5`}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  )
}
